// extracted by mini-css-extract-plugin
export var close = "cookie-popup-module--close--tluHW";
export var container = "cookie-popup-module--container--W3oYL";
export var content = "cookie-popup-module--content--Cn9oT";
export var overlay = "cookie-popup-module--overlay--+dT50";